import React, { useContext, useEffect, useRef, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { ToastContext, Badge } from '@forge/common';
import { useTranslation } from 'react-i18next';
import { ActivityAppDispatch, useActivitySelector } from '../../Redux/activityStore';
import { clearPendingToast } from '../../Redux/activitySlice';
import { selectPendingToast } from '../../Redux/activitySelectors';

const ActivityToastBridge: React.FC = () => {
  const { add } = useContext(ToastContext);
  const dispatch = useDispatch<ActivityAppDispatch>();
  const { t } = useTranslation();
  const pendingToast = useActivitySelector(selectPendingToast);

  const toastFnsRef = useRef({ add });
  toastFnsRef.current = { add };

  const toastOptions = useMemo(
    () => {
      if (!pendingToast) return null;
      
      const isSuccess = pendingToast.type === 'success';
      const badgeType = isSuccess ? 'success' : 'error';
      const badgeLabel = isSuccess ? t('activityLogToastSuccess') : t('activityLogToastError');
      const typeBadge = <Badge type={badgeType}>{badgeLabel}</Badge>;
      
      return { 
        type: typeBadge,
        subtitle: t(pendingToast.message), 
        lifetime: 4000, 
        showDismiss: false 
      };
    },
    [pendingToast, t],
  );

  useEffect(() => {
    if (!pendingToast || !toastOptions) return;
    toastFnsRef.current.add(toastOptions);
    dispatch(clearPendingToast());
  }, [pendingToast, toastOptions, dispatch]);

  return null;
};

export default ActivityToastBridge;
